"use client";

import { useTranslations } from "next-intl";
import { Stack, Text } from "@leabankab/component-library";
import { useDebtTypeOptions } from "../hooks/use-debt-type-options";
import { ResolvedConfirmDebtItem } from "../types";
import { DebtTypeIcon } from "./debt-type-icon";
import { FetchedDebtCard } from "./fetched-debt-card";

interface FetchedDebtListProps {
	debts: ResolvedConfirmDebtItem[];
}

export const FetchedDebtList = ({ debts }: FetchedDebtListProps) => {
	const t = useTranslations("pages.ConfirmDebtPage");
	const { labelFor, iconFor } = useDebtTypeOptions();

	if (debts.length === 0) {
		return <Text color="text.base">{t("fetched.empty")}</Text>;
	}

	return (
		<Stack render={<ul />} gap={1} className="m-0 list-none p-0">
			{debts.map((debt, index) => {
				const TypeIcon = iconFor(debt.type);

				return (
					<FetchedDebtCard
						key={index}
						debt={debt}
						typeLabel={labelFor(debt.type)}
						icon={TypeIcon && <DebtTypeIcon icon={TypeIcon} />}
					/>
				);
			})}
		</Stack>
	);
};
